module.exports = __webpack_public_path__ + "hyperion-v2-static/img/grid_highlight_blue.251f77e0.png";